import { render, staticRenderFns } from "./sendTestMediaConfirm.vue?vue&type=template&id=0142cf84&scoped=true"
import script from "./sendTestMediaConfirm.vue?vue&type=script&lang=js"
export * from "./sendTestMediaConfirm.vue?vue&type=script&lang=js"
import style0 from "./sendTestMediaConfirm.vue?vue&type=style&index=0&id=0142cf84&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0142cf84",
  null
  
)

export default component.exports